export default "__VITE_ASSET__lrtpXACY__"